import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=7a5d2fae&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5d2fae')) {
      api.createRecord('7a5d2fae', component.options)
    } else {
      api.reload('7a5d2fae', component.options)
    }
    module.hot.accept("./MenuBar.vue?vue&type=template&id=7a5d2fae&", function () {
      api.rerender('7a5d2fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/MenuBar.vue"
export default component.exports